import * as cn from 'classnames'
import * as styles from 'styles/pages/Styleguide.css'
import { Caption } from 'components/atoms/Text'

import { SingleColumnLayout } from 'components/layouts/Layouts'
import SidebarLayout from 'components/layouts/SidebarLayout'

const header = (
  <div className={ styles.dawn } style={{ height: '10rem' }} />
)

const body = (
  <div className={ styles.dusk } style={{ height: '20rem' }} />
)

const sidebar = (
  <div className={ styles.midnight } style={{ width: '100%' }}>
    Sidebar Content
  </div>
)

const SGLayouts = () => (
  <section className={ cn(styles.sgSection, styles.sgLayouts) }>
    <div className={ styles.sgLayout }>
      <SingleColumnLayout header={ header }>
        { body }
      </SingleColumnLayout>
      <Caption text='Single Column' />
    </div>
    <div className={ styles.sgLayout }>
      <SidebarLayout sidebar={ sidebar }>
        <SingleColumnLayout header={ header }>
          { body }
        </SingleColumnLayout>
      </SidebarLayout>
      <Caption text='Left Sidebar' />
    </div>
    <div className={ styles.sgLayout }>
      <SidebarLayout sidebar={ sidebar } sidebarRight>
        <SingleColumnLayout header={ header }>
          { body }
        </SingleColumnLayout>
      </SidebarLayout>
      <Caption text='Right Sidebar' />
    </div>
  </section>
)
export default SGLayouts
